import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { getStatusInfo } from '../utils/versionUtils';

/**
 * VersionStatusBadge Component
 * Displays a color-coded status badge for a version with tooltip
 */
const VersionStatusBadge = ({ status, onClick, clickable = false }) => {
  const statusInfo = getStatusInfo(status);

  const badge = (
    <Chip
      icon={statusInfo.icon}
      label={statusInfo.label}
      color={statusInfo.color}
      size="small"
      onClick={clickable ? onClick : undefined}
      sx={{
        cursor: clickable ? 'pointer' : 'default',
        '&:hover': clickable ? { opacity: 0.8 } : {},
      }}
    />
  );

  if (clickable) {
    return <Tooltip title="Click to change status">{badge}</Tooltip>;
  }

  return <Tooltip title={`Status: ${statusInfo.label}`}>{badge}</Tooltip>;
};

export default VersionStatusBadge;
